/**
 * Customer API Service
 */

import { apiClient } from './client'
import type {
  CustomerResponse,
  CustomerListResponse,
  CustomerFilterParams,
  CustomerReferralResponse,
} from '@/types/api'

/**
 * Get paginated list of customers with optional filters
 */
export async function getCustomers(params?: CustomerFilterParams): Promise<CustomerListResponse> {
  return apiClient.get<CustomerListResponse>('/customers', { params })
}

/**
 * Get a single customer by ID
 */
export async function getCustomer(id: string): Promise<CustomerResponse> {
  return apiClient.get<CustomerResponse>(`/customers/${id}`)
}

/**
 * Get referrals made by a customer
 */
export async function getCustomerReferrals(id: string): Promise<CustomerReferralResponse> {
  return apiClient.get<CustomerReferralResponse>(`/customers/${id}/referrals`)
}

export const customerService = {
  getCustomers,
  getCustomer,
  getCustomerReferrals,
}
